export default __webpack_public_path__ + "static/media/control-verbal-no-data.a41aba45.png";